// ========== BUNDLE MANAGER - VERSION PRODUCTION ==========
// Gère l'association des produits parents avec leurs composants (cadres, passe-partouts)
// via un système de bundle_id unique

let currentBundleId = null;
let bundleTimeout = null;
let addToCartCount = 0;
let pendingRequests = 0;

const BUNDLE_TIMEOUT_MS = 3000;

// ========== INTERCEPTION FETCH ==========
const originalFetch = window.fetch;

window.fetch = function(...args) {
  const [url, options] = args;

  // Interception ajout au panier
  if ((url.includes('/cart/add') || url.includes('add.js') || url === 'add') && options?.method === 'POST') {
    pendingRequests++;

    try {
      const body = options.body;

      if (body instanceof FormData) {
        // Créer un nouveau bundle_id pour chaque groupe de produits
        if (!currentBundleId || addToCartCount === 0) {
          currentBundleId = `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          addToCartCount = 0;
        }

        addToCartCount++;
        body.append('properties[_bundle_id]', currentBundleId);
        body.append('properties[_bundle_sequence]', addToCartCount.toString());

        resetBundleTimeout();
      }
    } catch (error) {
      console.error('Bundle Manager - Erreur interception fetch:', error);
    }

    const promise = originalFetch.apply(this, args);

    promise.finally(() => {
      pendingRequests--;
      if (pendingRequests === 0) {
        resetBundleTimeout();
      }
    });

    return promise;
  }

  // Interception modification de quantité
  if (url.includes('/cart/change') && options?.method === 'POST') {
    // Ne pas intercepter si appelé depuis removeProductWithComponents
    const stack = new Error().stack;
    if (stack && stack.includes('removeProductWithComponents')) {
      return originalFetch.apply(this, args);
    }

    return handleQuantityChange(url, options, args);
  }

  return originalFetch.apply(this, args);
};

// ========== INTERCEPTION XMLHttpRequest ==========
const originalXHROpen = XMLHttpRequest.prototype.open;
const originalXHRSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function(method, url, ...args) {
  this._method = method;
  this._url = url;
  this._isCartAdd = method === 'POST' &&
                    (url.includes('/cart/add') || url.includes('add.js') || url === 'add');
  return originalXHROpen.apply(this, [method, url, ...args]);
};

XMLHttpRequest.prototype.send = function(body) {
  if (this._isCartAdd) {
    pendingRequests++;

    try {
      if (typeof body === 'string') {
        const parsed = JSON.parse(body);

        if (!currentBundleId) {
          currentBundleId = `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          addToCartCount = 0;
        }

        parsed.properties = parsed.properties || {};
        parsed.properties._bundle_id = currentBundleId;

        addToCartCount++;

        body = JSON.stringify(parsed);
        resetBundleTimeout();
      }
    } catch (error) {
      console.error('Bundle Manager - Erreur interception XHR:', error);
    }

    const originalOnReadyStateChange = this.onreadystatechange;
    this.onreadystatechange = function() {
      if (this.readyState === 4) {
        pendingRequests--;
        if (pendingRequests === 0) {
          resetBundleTimeout();
        }
      }

      if (originalOnReadyStateChange) {
        originalOnReadyStateChange.apply(this, arguments);
      }
    };
  }

  return originalXHRSend.apply(this, [body]);
};

// ========== GESTION DU TIMEOUT ==========
function resetBundleTimeout() {
  clearTimeout(bundleTimeout);

  if (currentBundleId) {
    if (pendingRequests > 0) {
      return;
    }

    bundleTimeout = setTimeout(() => {
      currentBundleId = null;
      addToCartCount = 0;
      pendingRequests = 0;
    }, BUNDLE_TIMEOUT_MS);
  }
}

// ========== GESTION MODIFICATION DE QUANTITÉ ==========
async function handleQuantityChange(url, options, fetchArgs) {
  try {
    const body = JSON.parse(options.body);
    const lineNumber = parseInt(body.line);
    const newQuantity = body.quantity;

    const cart = await originalFetch('/cart.js').then(r => r.json());
    const itemIndex = lineNumber - 1;
    const item = cart.items[itemIndex];

    if (!item) {
      return originalFetch.apply(this, fetchArgs);
    }

    const bundleId = item.properties?._bundle_id;

    if (!bundleId) {
      return originalFetch.apply(this, fetchArgs);
    }

    // Si quantité = 0, c'est une suppression
    if (newQuantity === 0) {
      await removeProductWithComponents(lineNumber);
      return Promise.resolve(new Response(JSON.stringify({ success: true }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      }));
    }

    const bundleItems = cart.items
      .map((item, index) => ({ ...item, lineNumber: index + 1 }))
      .filter(item => item.properties?._bundle_id === bundleId);

    // Bloquer modification des composants gratuits
    if (item.price === 0) {
      alert('Cette option fait partie d\'un ensemble. Modifiez la quantité du produit principal.');
      return Promise.resolve(new Response(JSON.stringify({ error: 'Cannot modify component quantity' }), {
        status: 400,
        headers: { 'Content-Type': 'application/json' }
      }));
    }

    // Modifier le produit principal
    const response = await originalFetch.apply(this, fetchArgs);

    // Synchroniser les composants
    for (const bundleItem of bundleItems) {
      if (bundleItem.id !== item.id && bundleItem.price === 0) {
        await originalFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: bundleItem.lineNumber.toString(),
            quantity: newQuantity
          })
        });
      }
    }

    setTimeout(() => window.location.reload(), 500);
    return Promise.resolve(response);

  } catch (error) {
    console.error('Bundle Manager - Erreur gestion quantité:', error);
    return originalFetch.apply(this, fetchArgs);
  }
}

// ========== FONCTION DE SUPPRESSION ==========
async function removeProductWithComponents(lineToRemove) {
  const cart = await originalFetch('/cart.js').then(r => r.json());
  const itemIndex = lineToRemove - 1;
  const clickedItem = cart.items[itemIndex];

  if (!clickedItem) {
    return;
  }

  const bundleId = clickedItem.properties?._bundle_id;

  if (!bundleId) {
    await originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clickedItem.key, quantity: 0 })
    });
    window.location.reload();
    return;
  }

  // Supprimer tous les items avec le même bundle_id
  const itemsToRemove = cart.items.filter(item =>
    item.properties?._bundle_id === bundleId
  );

  for (const item of itemsToRemove) {
    try {
      await originalFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    } catch (error) {
      console.error('Bundle Manager - Erreur suppression:', error);
    }
  }

  window.location.reload();
}

// ========== EVENT LISTENER SUPPRESSION ==========
document.addEventListener('click', (e) => {
  const btn = e.target.closest('cart-remove-button button, cart-remove-button');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const wrapper = btn.closest('cart-remove-button');
  const line = Number(wrapper.dataset.index);

  removeProductWithComponents(line);
});

// ========== NETTOYAGE AUTOMATIQUE DES ORPHELINS ==========
fetch('/cart.js').then(r => r.json()).then(cart => {
  const bundles = {};
  cart.items.forEach(item => {
    const bid = item.properties?._bundle_id || 'sans_bundle';
    if (!bundles[bid]) bundles[bid] = { items: [], hasParent: false };
    bundles[bid].items.push({ key: item.key, title: item.title, price: item.price });
    if (item.price > 0) bundles[bid].hasParent = true;
  });

  // Détecter et nettoyer les orphelins
  const orphanBundles = [];
  Object.entries(bundles).forEach(([bundleId, bundle]) => {
    if (bundleId !== 'sans_bundle' && !bundle.hasParent) {
      orphanBundles.push({ bundleId, items: bundle.items });
    }
  });

  if (orphanBundles.length > 0) {
    const cleanOrphans = async () => {
      for (const orphan of orphanBundles) {
        for (const item of orphan.items) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          } catch (error) {
            console.error('Bundle Manager - Erreur nettoyage orphelins:', error);
          }
        }
      }
      setTimeout(() => window.location.reload(), 500);
    };

    cleanOrphans();
  }
}).catch(error => {
  console.error('Bundle Manager - Erreur analyse panier:', error);
});